<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" :selectedBackground="selectedRow" :buttoncaption="caption" :sidebarHeader="sbarHeader" @saveData="dataSaved" @closeSidebar="addNewDataSidebar = false" />

    <vs-table ref="backgroundTable" class="vs-con-loading__container" v-model="selected" @selected="handleselector" pagination :max-items="itemsPerPage" search :data="backgrounds">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div :buttoncaption="caption" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showSidebar">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ backgrounds.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : backgrounds.length }} of {{ backgrounds.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="description">Description</vs-th>
        <vs-th sort-key="modifiedOn">Modified On</vs-th>
        <vs-th sort-key="modifiedBy">Modified By</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <img :src="tr.thumbnailUrl" height=100% />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedOn.replace("T", " ").split('.')[0] }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedBy  }}</p>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import AddNewDataSidebar from './BackgroundForm.vue';

export default {
  components: {
    AddNewDataSidebar
  },
  data() {
    return {
      selected: [],
      backgrounds: [],
      itemsPerPage: 6,
      isMounted: false,
      addNewDataSidebar: false,
      selectedRow: {},
      caption: "",
      sbarHeader: ""
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.backgroundTable.currentx
      }
      return 0
    },
  },
  methods: {
    handleselector(tr) {
      this.addNewDataSidebar = true;
      this.selectedRow = tr;
      this.caption = "Update";
      this.sbarHeader = "Update Background";
    },
    showSidebar(){
      this.addNewDataSidebar = true;
      this.selectedRow = {};
      this.caption = "Add";
      this.sbarHeader = "Add Background";
    },
    dataSaved(){
      this.addNewDataSidebar = false;
      this.loadData();
    },
    loadData() {
      const self = this;
      self.showLoadingOnTable();

      var onSuccess = function (response) {
        self.backgrounds = response.data
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.backgroundTable.$el);
        self.$refs.backgroundTable.searchx = "";
      };
      
      self.$ajaxGet(self, "background", onSuccess, onFinally);
    },
    showLoadingOnTable(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.backgroundTable.$el,
        scale: 1
      });
    },
  },
  mounted() {
    this.loadData();
    this.isMounted = true;

    if(this.$route.path == "/digi/backgrounds")
      this.$store.dispatch("updateTheme", "dark");
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {

              span {
                display: flex;
                justify-content: center;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
